module.exports = __webpack_public_path__ + "static/media/img-3.d68eb657.jpeg";